import { div, button } from '../utils/dom';
import { ICON_PLUS, ICON_MINUS } from '../constants/icons';

interface ZoomButtonsCallbacks {
  onZoomIn: () => void;
  onZoomOut: () => void;
  getFitScale: () => number;
  getMaxScale: () => number;
}

const CLASSNAME_ZOOM_BUTTONS = 'mapplic-zoom-buttons';
const CLASSNAME_ZOOM_BUTTON = 'mapplic-zoom-button';

const ARIA_LABEL_ZOOM_IN = 'Karte vergrößern';
const ARIA_LABEL_ZOOM_OUT = 'Karte verkleinern';

export class ZoomButtons {
  public readonly rootElem: HTMLElement;
  private zoomInBtn: HTMLButtonElement;
  private zoomOutBtn: HTMLButtonElement;

  constructor(
    private callbacks: ZoomButtonsCallbacks
  ) {
    this.rootElem = this.createZoomButtons();
    this.zoomInBtn = this.rootElem.querySelector(`.${CLASSNAME_ZOOM_BUTTON}[data-zoom="in"]`)!;
    this.zoomOutBtn = this.rootElem.querySelector(`.${CLASSNAME_ZOOM_BUTTON}[data-zoom="out"]`)!;

    this.bindEvents();
  }

  private createZoomButtons(): HTMLElement {
    const wrapper = div({
      className: CLASSNAME_ZOOM_BUTTONS
    });

    // Zoom Out Button
    const zoomOutBtn = button({
      className: CLASSNAME_ZOOM_BUTTON,
      attributes: {
        'data-zoom': 'out',
        type: 'button',
        'aria-label': ARIA_LABEL_ZOOM_OUT
      },
      html: ICON_MINUS
    });
    wrapper.appendChild(zoomOutBtn);

    // Zoom In Button
    const zoomInBtn = button({
      className: CLASSNAME_ZOOM_BUTTON,
      attributes: {
        'data-zoom': 'in',
        type: 'button',
        'aria-label': ARIA_LABEL_ZOOM_IN
      },
      html: ICON_PLUS
    });
    wrapper.appendChild(zoomInBtn);

    return wrapper;
  }

  private bindEvents(): void {
    this.zoomInBtn.addEventListener('click', () => this.handleZoomIn());
    this.zoomOutBtn.addEventListener('click', () => this.handleZoomOut());
  }

  private handleZoomIn(): void {
    this.callbacks.onZoomIn();
  }

  private handleZoomOut(): void {
    this.callbacks.onZoomOut();
  }

  /**
   * Update button states based on current zoom level
   */
  public update(scale: number): void {
    const fitScale = this.callbacks.getFitScale();
    const maxScale = this.callbacks.getMaxScale();

    this.zoomOutBtn.disabled = Math.abs(scale - fitScale) < 0.01;
    this.zoomInBtn.disabled = Math.abs(scale - maxScale) < 0.01;
  }
}
